import { CircularProgress, Typography } from "@material-ui/core";
import CustomModal, { useModal } from "components/Modal";
import Row from "components/Row";
import KhaltiCheckout from "khalti-web";
import { ModalCard } from "modules/profile/Profile";
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { getPricingPlans, verifyKhaltiPayment } from "./firebase";
import PricingCard from "./PlanCard";

export default function Topup() {
  const [plans, setPlans] = useState([]);
  const [message, setMessage] = useState();
  const [verifing, setVerifing] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState();
  const editModal = useModal();

  useEffect(() => {
    getPricingPlans().then(plans => {
      setPlans(plans);
    });

  }, []);

  function buyPlan(plan) {
    setSelectedPlan(plan);
    editModal.open();
  }

  function payWithKhalti() {
    // TODO: Better config
    let khaltiConfig = {
      publicKey: "test_public_key_504c36beef7e47d2a342d74c6f8c9336",
      productIdentity: selectedPlan.product_sku,
      productName: selectedPlan.name,
      productUrl: "medilink.com/pricingPlan",
      merchant_value: selectedPlan.exams,
      eventHandler: {
        async onSuccess(payload) {
          setVerifing(true);
          var resp = await verifyKhaltiPayment(payload, selectedPlan);
          setVerifing(false);
          setMessage(resp.message);
          if (resp.success) {
            // TODO: Payment succeceded notice UI
          } else {
            // TODO: User ko paisa katyo bhancha but topup bhayena follow up his issue.
          }
          setSelectedPlan(null);
        },
        onError() {
          setSelectedPlan(null);
        },
        onClose() {
          console.log("widget is closing");
        }
      }
    };
    let checkout = new KhaltiCheckout(khaltiConfig);
    checkout.show({ amount: selectedPlan.price_khalti });
  }

  function payWithEsewa() {
    // TODO: setup their sdk
  }

  function getCardContent() {
    if (verifing) return <CircularProgress />;
    else if (message) return <div>{message}</div>;
    else
      return (
        <>
          <div>Pay Using</div>
          <PaymentLogo
            src="https://www.nepalitrends.com/wp-content/uploads/2018/03/khalti.png"
            onClick={payWithKhalti}
          />
          <PaymentLogo
            src="https://www.nepalitrends.com/wp-content/uploads/2018/03/esewa.png"
            onClick={payWithEsewa}
          />
        </>
      );
  }

  return (
    <TopUpContainer>
      <Row>
        {plans.map(p => (
          <PricingCard
            plan={p}
            onSelected={() => {
              buyPlan(p);
            }}
          />
        ))}
      </Row>
      <CustomModal
        {...editModal.props}
        onClose={() => {
          setSelectedPlan(null);
          editModal.close();
        }}
      >
        <ModalCard>{getCardContent()}</ModalCard>
      </CustomModal>
    </TopUpContainer>
  );
}

export const CardTitle = styled(Typography)`
  && {
    font-weight: 800;
    font-size: 18;
  }
`;

export const PaymentLogo = styled.img`
  && {
    width: 100px;
    padding: 10px;
  }
`;

export const TopUpContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 100vh;
  width: 100%;
  background: linear-gradient(
    to bottom left,
    ${props => props.theme.palette.primary["500"]},
    ${props => props.theme.palette.primary["700"]}
  );
  &:before {
    position: absolute;
    content: "";
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background-image: url("https://images.pexels.com/photos/1932264/pexels-photo-1932264.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260");
    opacity: 0.1;
    z-index: 1;
  }
`;
